import { useInstancesByQuery } from 'hive-react-utils';
import { useMyPatient } from './useMyPatient';
import moment from 'moment';
export function useMyJournalsByDate(startDate, endDate) {
    const patient = useMyPatient();
    return useInstancesByQuery('ecarepd', 'journalsByPatientIDFromDate', 'journal', {}, (patient === null || patient === void 0 ? void 0 : patient.properties.patientID) || '', moment(startDate).startOf('day').toISOString(), moment(endDate).endOf('day').toISOString());
}
